<template>
  <div>
    <div style="width:100%;height:100px;margin-top:50px;">
        <span style="width:100%;height:60px;line-height:60px;margin:0 auto;padding:0;display:block;text-align:center;color:black;font-size:20px;font-weight:bold;">
            {{ company.name }}收费标准及检测报告保障说明
        </span>
    </div>
    <a-spin tip="加载中..." 
    style="width:100%;text-align:center;margin-top:20px;margin-bottom:20px;" 
    :spinning="loading">
    </a-spin>
    <div style="margin-left:2vw;margin-right:2vw;margin-top:20px;" v-if="!loading">
        <a-table
            :columns="columns"
            :data-source="data"
            bordered
            :pagination="false"
        />
        <div
        slot="txt"
        slot-scope="value"
        >
            <span style="white-space: pre-line">
                {{ value }}
            </span>
        </div>
    </div>
    
    <div style="width:100%;height:70px;margin-top:50px;text-align:center;position:relative;bottom:0;">
        <span style="line-height:70px;text-align:center;color:#323136;">
            {{ company.copyright_no }} 版权所有
        </span>
        <a style="text-align: center;width:100%;line-height: 20px;height:20px;display:block;" href="https://beian.miit.gov.cn" target="_blank">{{ company.record_no }}</a>
    </div>
  </div>
</template>

<script>

import request from '../../api/request'
import urls from '../../api/urls'
import user_model from '../../model/user'
import menu_model from '../../model/menu'
import company_model from '../../model/company'
import watermark from 'watermark-dom'

const columns = [
  {
    title: '评估价',
    dataIndex: 'judge_price',
    key: 'judge_price',
    width: 300,
    align: 'center',
  },
  {
    title: '检测费',
    dataIndex: 'price',
    key: 'price',
    width: 100,
    align: 'center',
  },
  {
    title: '检测报告保障',
    children: [
      {
        title: '保障期限',
        dataIndex: 'expires_days',
        key: 'expires_days',
        width: 100,
        fixed: 'top',
        align: 'center',
        scopedSlots: {
            customRender: 'txt'
        },
        customRender: (text, row) => {
            return {
              children: `${text}`,
              attrs: {
                rowSpan: row.expires_daysRowSpan
              }
            }
        }
      },
      {
        title: '保障项目',
        dataIndex: 'group_name',
        key: 'group_name',
        width: 200,
        fixed: 'top',
        align: 'center',
        scopedSlots: {
            customRender: 'txt'
        },
        customRender: (text, row) => {
            return {
              children: `${text}`,
              attrs: {
                rowSpan: row.group_nameRowSpan
              }
            }
        }
      },
    ],
  },
];

export default {
    name: 'OrderPrice',
    head: {
        title: "收费标准",
        meta:[
            { name: 'description', content: '收费标准'}
        ]
    },
    data() {
        return {
            page: 1,
            page_count: 10,
            user: user_model,
            urls: urls,
            order_list: [
            ],
            order_list_total_count: 0,
            total_page_count: 0,
            order: 1,  // 排序， 0 => 未检测订单, 1=> 已检测订单, 3 => 搜索
            reloadOrderListKey: 0,
            searchPlaceHolder: '输入搜索关键字',
            searchModalVisible: false,
            searchMode: "license_plate",
            searchKeyWord: "",
            searchClicked:false,
            mode_choices: {
                "Primary": "初级",
                "Intermediate": "中级",
                "Advanced": "高级",
            },
            menu: menu_model,
            show_turn_to_page_modal: false,
            turn_to_page: 1,
            confirm_loading: false, 
            loading: false,
            turn_confirm_loading: false, 
            company: company_model,
            inspector_list: [],
            asign_inspector_modal_visible: false,
            asign_inspector_confirm_loading: false,
            asign_order: {},
            asign_inspector_id: undefined,
            data:[],
            columns,
        }
    },
    methods: {
        rowSpan(key) {
            let arr = this.data
                .reduce((result, item) => {
                    if (result.indexOf(item[key]) < 0) {
                        result.push(item[key])
                    }
                    return result
                }, [])
                .reduce((result, keys) => {
                const children = this.data.filter((item) => item[key] === keys)
                result = result.concat(
                    children.map((item, index) => ({
                        ...item,
                        [`${key}RowSpan`]: index === 0 ? children.length : 0
                    }))
                )
                return result
                }, [])
            this.data = arr
        },
        
        _isMobile() {
            let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
            return flag;
        },
        responsefetch_menu_price_list() {
            this.loading = true;
            request.order.menu_price_list().then((response) => {
                this.loading = false
        // handle success
                if (response.status == 200 && response.data.code == 0) {
                    if (response.data && response.data.data) {
                        var data = response.data.data
                        this.data = []
                        for (var menu_price of data) {
                            let index = data.indexOf(menu_price)
                            let appraisal_price_end = menu_price['appraisal_price_end']
                            let appraisal_price_start = menu_price['appraisal_price_start']
                            let end = String(parseInt(appraisal_price_end/10000))
                            let start = String(parseInt(appraisal_price_start/10000))
                            if (appraisal_price_start == 0) {
                                menu_price['judge_price'] = end+"万以内（不含"+end+"万）"
                            }
                            else if (appraisal_price_end == 0) {
                                menu_price['judge_price'] = start+"万以上"
                            }
                            else {
                                menu_price['judge_price'] = start+"万-"+end+"万（不含"+end+"万）"
                            }
                            if (menu_price['mode'] == 'DEFAULT') {
                                let price = menu_price['price']
                                if (price) {
                                    menu_price['price'] = String(price) + "元"
                                }
                            }
                            else if (menu_price['mode'] == 'PERSENT_OF_PRICE') {
                                let persent_of_price = menu_price['persent_of_price']
                                if (persent_of_price) {
                                    menu_price['price'] = "成交价的" + String(persent_of_price) + "%"
                                }
                            }
                            let group_name_list = []
                            if (menu_price.groups) {
                                for (let group of menu_price.groups) {
                                    group_name_list.push(group.name)
                                }
                            }
                            menu_price['group_name'] = group_name_list.join(', ')
                            menu_price['key'] = index
                            if (menu_price.expires_days) {
                                menu_price.expires_days = String(menu_price.expires_days) + "天内"
                            }
                            this.data.push(menu_price)
                            this.rowSpan('expires_days') // 合并title
                            this.rowSpan('group_name') // 合并部门
                        }
                    }
                }
                else {
                    this.$message.error("获取收费标准信息失败")
                }
            })
            .catch((error) => {
                this.loading = false
                if (error) {
                    this.$error({
                        title: "请求失败，请联系管理员",
                        content: String(error),
                    });
                }
            })
            .then(function () {
                // always executed
            });
        },
        fetch_company() {
            let company_info_resp = request.company.company()
            company_info_resp.then((response) => {
                if (response.status == 200 && response.data.code == 0) {
                    if (response.data.data) {
                        this.company = response.data.data
                    }
                }
            })
        },
        load() {
            this.loading = true;
            try {
                watermark.remove()
            }
            catch (err) {
                console.log()
            }
            this.fetch_menu_price_list()
            this.fetch_company()
            // user_info
            this.fetch_user_info()
        },
        fetch_user_info() {
            let user_info_resp = request.site_user.userinfo()
            user_info_resp.then((response) => {
                var failed_message = "获取用户信息失败"
                if (response.status == 200 && response.data.code == 0) {
                    if (response.data && response.data.data) {
                        this.user = response.data.data
                    }
                }
                else {
                    if (response.data && response.data.message) {
                        failed_message = response.data.message
                    }
                    this.$message.error(failed_message)
                }
            })
            
        },
    },
    created() {
        this.load()
    },
    components: {

    }
}
</script>